<template>
  <div class="flex justify-around items-center p-0 rounded" disabled>
    <input type="text" class=" w-full bg-gray-400 text-sm m-1 rounded px-1" v-model="manualEdit" :disabled="!editWord"></input>
    <button class="focus:outline-none m-1" v-if="!editWord" @click="editTheWord">
      <i class="fas fa-edit text-xl text-blue-300 hover:text-blue-500"></i>
    </button>
    <button class="focus:outline-none m-1" v-else @click="submitEditingWord">
      <i class="fas fa-check-square text-xl text-green-300 hover:text-green-500"></i>
    </button>
  </div>
</template>

<script>
import { getTheWordCoordinate } from '@/helpers';

export default {
  props: [
    'value',
    'type',
    'startEditingWord',
    'finishEditingWord'
  ],
  data() { 
    return {
      editWord: false,
      manualEdit: '',
    }
  },
  created() {
    this.manualEdit = this.value;
  },
  methods: {
    editTheWord() {
      this.editWord = true;
      this.startEditingWord(this.type);
    },
    submitEditingWord() {
      this.editWord = false;
      this.finishEditingWord();
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.manualEdit = this.value;
      },
      deep: true
    },
  }
}
</script>

<style>

</style>